import { render, staticRenderFns } from "./DeliveryBadge.vue?vue&type=template&id=1c9d03f1&scoped=true"
import script from "./DeliveryBadge.vue?vue&type=script&lang=js"
export * from "./DeliveryBadge.vue?vue&type=script&lang=js"
import style0 from "./DeliveryBadge.vue?vue&type=style&index=0&id=1c9d03f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9d03f1",
  null
  
)

export default component.exports